'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { RegistrationStatus, UserType } from '@/types/pam-api';
import useUser from '@/utils/use-user';
import { GTM_ID, IS_SET_USER_ATTRIBUTE_STORAGE_KEY } from './constants';
import { EventDataMap, sendPageViewEvent, sendUserAttributesEvent, sendUserIdEvent } from './datalayer';
export default function GTMBody() {
  const pathname = usePathname();
  const {
    isLoggedIn,
    user
  } = useUser();
  useEffect(() => {
    if (isLoggedIn && sessionStorage.getItem(IS_SET_USER_ATTRIBUTE_STORAGE_KEY) !== 'set') {
      let userType: EventDataMap['user_attributes']['data']['user_type'] = null;
      if (user?.userType) {
        userType = user.userType.toLowerCase() as Lowercase<UserType>;
      } else if (user?.registrationStatus === RegistrationStatus.NewUser) {
        userType = 'new';
      }
      sendUserAttributesEvent({
        data: {
          logged_in: isLoggedIn ? 'true' : 'false',
          user_id: user?.id || null,
          aov: user?.aov || null,
          user_type: userType,
          total_order: user?.totalOrder ?? 0,
          last_purchase: user?.lastPurchaseDay ?? null,
          city: user?.lastAddressCityName ?? null,
          province: user?.lastAddressProvinceName ?? null
        }
      });
      sendUserIdEvent({
        user_id: user?.id || null
      });
      sessionStorage.setItem(IS_SET_USER_ATTRIBUTE_STORAGE_KEY, 'set');
    }
  }, [pathname, isLoggedIn, user?.id, user?.aov, user?.userType, user?.totalOrder, user?.lastPurchaseDay, user?.lastAddressCityName, user?.lastAddressProvinceName, user?.registrationStatus]);
  useEffect(() => {
    if (!pathname) return;
    sendPageViewEvent({
      page: pathname
    });
  }, [pathname]);
  return <noscript data-sentry-component="GTMBody" data-sentry-source-file="gtm-body.tsx">
            <iframe src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`} height='0' width='0' className='invisible hidden' title='GTAG'></iframe>
        </noscript>;
}